import styled from 'styled-components'

import FormSubmitButton from '../../form/FormSubmitButton'
import FormikForm from '../../form/FormikForm'
import FormFieldSelect from '../../form/fields/FormFieldSelect'
import FormFieldInput from '../../form/fields/FormFieldInput'
import FormFieldTextArea from '../../form/fields/FormFieldTextArea'
import FormFieldFile from '../../form/fields/FormFieldFile'
import Icon from '../../components/Icon'
import FormFieldCheckbox from '../../form/fields/FormFieldCheckbox'
import FormFieldDate from '../../form/fields/FormFieldDate'
import FormFieldPhone from '../../form/fields/FormFieldPhone'

export const Container = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Form = styled(FormikForm)`
  width: 100%;
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const AddressBlock = styled.div`
  label {
    font-size: 1.5rem;
  }
`

export const AvailabilityBlock = styled.div`
  label {
    font-size: 1.5rem;
  }
`

export const AvailabilityAddressWrapperFirstLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;

  > div {
    width: 20rem;
  }
`

export const AvailabilityAddressWrapperSecondLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 2rem;

  > div {
    width: 20rem;
  }
`

export const AddressFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const LastAddressFieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  ${({ theme }) => theme.breakpoints.up('tablet')} {
    flex-direction: row;
    > div {
      flex: 1;
    }
  }
`

export const AddressTitle = styled.h3`
  color: ${({ theme }) => theme.colors.bluePrimary};
  ${({ theme }) => theme.textStyles.firaSansLg};
  margin: 0;
`

export const Line = styled.span`
  display: block;
  width: 2.5rem;
  height: 2px;
  background-color: ${({ theme }) => theme.colors.bluePrimary};
  margin-bottom: 2rem;
`

export const Select = styled(FormFieldSelect)``

export const Input = styled(FormFieldInput)``
export const PhoneField = styled(FormFieldPhone)``

export const TextArea = styled(FormFieldTextArea)``

export const DateField = styled(FormFieldDate)``

export const UploadFile = styled(FormFieldFile)``

export const UploadIcon = styled(Icon)``

export const CheckboxField = styled(FormFieldCheckbox)`
  margin-top: 3.5rem;
`

export const Chart = styled.div`
  margin-top: 2rem;
`

export const ChartTitleLink = styled.p`
  &,
  & * {
    ${({ theme }) => theme.textStyles.firaSansLgBold};
    color: ${({ theme }) => theme.colors.blueSecondaryBis};
  }

  & a {
    text-decoration: underline;
  }
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  margin: 3.6rem auto 0 auto;
`

export const SubmitButton = styled(FormSubmitButton)``

export const SubmissionValidationText = styled.p`
  ${({ theme }) => theme.textStyles.montserratXl};
  margin-top: 3.4rem;
`
